module.exports = __webpack_public_path__ + "static/media/alert.013ada20.png";